
import { createVNode, defineComponent } from 'vue';
import { mapState } from 'vuex';
import { Modal } from 'ant-design-vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import moment from 'moment';
import numeral from 'numeral';
import Banner from '@/components/banner/Banner.vue';
import BackArrowIcon from '@/components/icons/BackArrowIcon.vue';
import DownloadIcon from '@/components/icons/DownloadIcon.vue';
import { getOrderDetail, getInternaion, copyOrder } from '@/api/apis';
import { downloadFile } from '@/api/request';
import { baseUrl } from '@/utils/constants';

interface PartOrderDetailProps {
  detail: any;
  [key: string]: any;
}

export default defineComponent({
  name: 'PartOrderDetail',
  components: {
    Banner,
    BackArrowIcon,
    DownloadIcon
  },
  created() {
    const id = +(this.$route.params.id as string);
    if (!isNaN(id) && id > 0) {
      this.id = id;
      this.loadData();
    }
  },
  data(): PartOrderDetailProps {
    return {
      moment,
      numeral,
      id: 0,
      loading: false,
      colTitle: [
        'vehicle_name',
        'part_type',
        'part_name',
        'part_no',
        'part_code',
        'unit',
        'quantity',
        'unit_price',
        'total_price',
        'remark'
      ],
      columns: [
        {
          dataIndex: 'vehicleName',
          width: 120,
          slots: { title: 'vehicle_name-title', customRender: 'vehicleName' }
        },
        {
          dataIndex: 'atlaName',
          width: 120,
          slots: { title: 'part_type-title', customRender: 'atlaName' }
        },
        {
          dataIndex: 'name',
          width: 100,
          slots: { customRender: 'name', title: 'part_name-title' }
        },
        {
          dataIndex: 'modelNum',
          width: 100,
          slots: { title: 'part_no-title', customRender: 'modelNum' }
        },
        {
          dataIndex: 'partCode',
          width: 100,
          slots: { title: 'part_code-title', customRender: 'part-code' }
        },
        {
          dataIndex: 'unit',
          width: 100,
          slots: { customRender: 'unit', title: 'unit-title' }
        },
        {
          dataIndex: 'totalQuantity',
          width: 100,
          slots: { customRender: 'quantity', title: 'quantity-title' }
        },
        {
          dataIndex: 'sellingPrice',
          width: 100,
          slots: { customRender: 'unitPrice', title: 'unit_price-title' }
        },
        {
          dataIndex: 'totalPrice',
          width: 100,
          slots: { customRender: 'totalPrice', title: 'total_price-title' }
        },
        {
          dataIndex: 'remark',
          width: 120,
          slots: { title: 'remark-title' }
        }
      ],
      dataSource: [],
      detail: {},
      moneyTypes: [],
      isCopying: false
    };
  },
  methods: {
    getTotalPrice() {
      const res = numeral(0);

      this.detail.offSellingPrice
        ? res.add(this.detail.offSellingPrice || 0)
        : res.add(this.detail.totalSellingPrice || 0);
      const currency = this.getCurrency(this.detail);

      const value = res.value();
      return value ? currency + res.format('0,0.00') : '';
    },
    async handleDownload() {
      const paramArr: string[] = [];

      paramArr.push(`customerId=${this.userInfo.id}`);
      paramArr.push(`locale=${this.lang}`);
      const moneyType = this.detail.moneyType
        ? this.$t(this.detail.moneyType)
        : '';
      if (moneyType) {
        paramArr.push(`moneyType=${moneyType}`);
      }

      await downloadFile(
        `${baseUrl}ureport/excel?_u=db:user_part_order_detail_export.ureport.xml&orderId=${
          this.id
        }&${paramArr.join('&')}`,
        this.$t('order.order_title') + '.xlsx',
        null
      );
    },
    getCurrency(record) {
      let res = '';
      const moneyType = record.moneyType;

      if (moneyType) {
        const item: any = this.moneyTypes.find(
          (s: any) => s.code === moneyType
        );

        res = item ? item.val : '';
      }
      return res;
    },
    getOrderStatus(status) {
      let res = '';

      if (!isNaN(status) && status !== null && status >= 0) {
        res = this.$t(`order_status.${status}`);
      }
      return res;
    },
    async loadData() {
      this.loading = true;

      const dRes = await getInternaion({ type: 8 }); // 货币;

      if (dRes.success) {
        this.moneyTypes = dRes.result || [];
      }

      const res = await getOrderDetail({
        id: this.id
      });

      if (res.success) {
        this.detail = res.result || {};

        this.dataSource = this.detail.orderDetailList || [];
      }

      this.loading = false;
    },
    handleBack() {
      this.$router.push('/order?tab=2');
    },
    handleReorder() {
      Modal.confirm({
        // title: 'Are you sure delete this task?',
        icon: createVNode(ExclamationCircleOutlined),
        content: this.$t('shopping_cart.reorder_confirm'),
        okText: this.$t('shopping_cart.confirm'),
        cancelText: this.$t('shopping_cart.cancel'),
        onOk: async () => {
          if (this.id > 0) {
            this.isCopying = true;
            const res = await copyOrder({
              id: this.id
            });

            if (res.success) {
              this.handleBack();
            }

            this.isCopying = false;
          }
        }
      });
    },
    gotoDiagramDetail(record) {
      if (record.groupId) {
        this.$router.push(`/part-detail/${record.groupId}`);
      } else if (record.vehicleId) {
        this.$router.push(`/spare-part/${record.vehicleId}`);
      }
    }
  },
  computed: {
    ...mapState(['lang', 'userInfo']),
    totalSummary(): string {
      let res = numeral(0);

      this.dataSource.forEach(d => {
        res = res.add(d.totalPrice || 0);
      });

      const moneyIcon = '$';

      const value = res.value();

      return value ? moneyIcon + res.format('0,0.00') : '';
    }
  }
});
